import { render, staticRenderFns } from "./ExceptionsTab.vue?vue&type=template&id=0d973d9e"
import script from "./ExceptionsTab.vue?vue&type=script&lang=js"
export * from "./ExceptionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports